import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PortfolioTagActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/PortfolioTag/PortfolioTagBrowser")
	}

	render() {
		return (
			<Activity 
				name="PortfolioTag"
				RenderedComponent={this.RenderedComponent}
                context="PortfolioTag"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PortfolioTagActivity)